/* eslint-disable no-undef */
import request from './request'
import {getCookie} from "@/helpers";
import {api} from "./requestGraphql";

const getCampaigns = async (data) => {
  try {
    data = (!data.payload) ? data.payload = {} : data

    let queryData = new URLSearchParams()
    queryData.append('payload', JSON.stringify(data.payload))

    const workspace = localStorage.getItem('workspace');

    const result = await request.get('/campaigns/getCampaigns', {
      params: queryData,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': workspace
      }
    })

    if (!result.data.success) {
      throw new Error(result.data.message || 'Error while getting data');
    }

    return result.data

  } catch (err) {
    console.error(err)
    throw err;
  }
}

const getOfferNames = async (data) => {
  try {
    data.searchOffer = (!data.searchOffer) ? '' : data.searchOffer

    const result = await request.get(`/campaigns/getOfferNames`, {
      params: {
        searchOffer: data.searchOffer
      },
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getCampaignNames = async (data) => {
  try {
    data.searchCampaignName = (!data.searchCampaignName) ? '' : data.searchCampaignName

    const result = await request.get(`/campaigns/getCampaignNames`, {
      params: {
        searchCampaignName: data.searchCampaignName
      },
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffNamesIds = async (data) => {
  try {
    data.searchAffName = (!data.searchAffName) ? '' : data.searchAffName

    const workspace = localStorage.getItem('workspace');

    const result = await request.get(`/campaigns/getAffNamesIds`, {
      params: {
        searchAffName: data.searchAffName
      },
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': workspace
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const campaignHistory = async (id) => {
  try {

    const result = await api.post(
        '', {
          query: `
          {
            campaignHistory(id: ${id}){
               user
               action
               dateAdded
               logs
            }
        }`,
    })

    return result.data.data.campaignHistory

  } catch (error) {
    
  }
}

const getManagersNamesIds = async (data) => {
  try {
    data.searchManagersName = (!data.searchManagersName) ? '' : data.searchManagersName

    const workspace = localStorage.getItem('workspace');

    const result = await request.get(`/campaigns/getManagersNamesIds`, {
      params: {
        searchManagersName: data.searchManagersName
      },
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': workspace
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getCampaignStatuses = async (token) => {
  try {

    const result = await request.get(`/campaigns/getCampaignStatuses`, {
      headers: {
        'Authorization': token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getUsers = async (data) => {
  try {

    const result = await request.get(`/campaigns/getUsers`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const createCampaignDeprecated = async (data) => {
  try {

    const res = await request.get(`/campaigns/createCampaign`, {
      params: data.params,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return res.data

  } catch (err) {
    console.error(err)
  }
}

const createCampaign = async (data) => {
  try {
    const saleRedirectOfferId = data.params.saleRedirectOfferId !== 0 ?  data.params.saleRedirectOfferId : null;
    const clickRedirectOfferId = data.params.clickRedirectOfferId !== 0 ? data.params.clickRedirectOfferId : null;

    const res = await api.post(
      '', {
        query: `
          mutation{
            createCampaign(
                  affiliateId:${data.params.affiliateId}
                  offerId: ${data.params.offerId}
                  user: "${data.params.user}"
                  payout: ${data.params.payOut},
                  payoutPercent: ${data.params.payoutPercent}
                  name: "${data.params.name}",
                  clickAmountDay: ${data.params.clickAmountDay},
                  clickAmountWeek: ${data.params.clickAmountWeek},
                  clickAmountMonth: ${data.params.clickAmountMonth},
                  saleAmountDay: ${data.params.saleAmountDay},
                  saleAmountWeek: ${data.params.saleAmountWeek},
                  saleAmountMonth: ${data.params.saleAmountMonth},
                  saleRedirectOfferId: ${saleRedirectOfferId},
                  clickRedirectOfferId: ${clickRedirectOfferId},
                  start: "${data.params.start}",
                  end: "${data.params.end}",
                  useCaps: ${data.params.useCaps},
                  marginType: "${data.params.marginType}",
                  subIds: "${data.params.subIds}",
                  variantId: ${data.params.variantId}
            ){
                  id
                  status
                  payOut
                  name
            }
        }`,
      }, {
        headers: {
          workspace: 'gotzha'
        }
      }
    )

    if(res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    return res.data.data.createCampaign;

  } catch (err) {
    console.error(err)
    throw err;
  }
}

const getCampaignUrl = async (data) => {
  try {

    let res = await request.get(`/campaigns/getCampaignUrl`, {
      params: data.params,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
    return res.data
  } catch (err) {
    console.error(err)
  }
}

const updateCampaign = async ({id, status, payOut, name, percentPayout, marginType, pingRate, postbackUrl, affiliateMultiPings}) => {

  try {
    const res = await api.post(
        '', {
          query: `
                    mutation{
                          updateCampaign(
                                id:${id},
                                status: "${status}",
                                payOut: ${payOut},
                                percentPayout: ${percentPayout},
                                name: "${name}",
                                marginType: "${marginType}",
                                pingRate: ${pingRate},
                                postbackUrl: "${postbackUrl}",
                                affiliateMultiPings: ${affiliateMultiPings}
                          ){
                                id
                                status
                                payOut
                                name
                                percentPayout
                                marginType
                                pingRate
                                affiliateMultiPings
                          }
                    },

            `,
        }
    )

    const response = res.data.data.updateCampaign;
    console.log(`\ncreate Campaign updated: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getPingRate = async (id) => {
  try {

    const res = await api.post(
        '', {
          query: `
            {
              campaignPingRate(id:${id})
            }
          `
        }
    )

    return res.data.data.campaignPingRate

  } catch (error) {
    console.error(error)
  }
}

const updateCap = async (data) => {

  const startDate = data.startDate ? `"${data.startDate}"` : null;
  const endDate = data.startDate ? `"${data.endDate}"` : null;

  try {
    const res = await api.post(
        '', {
          query: `
                  mutation{
                    updateCap(
                            id: ${data.id},
                            campaignId: ${data.campaignId},
                            clicksDay: ${data.clicksDay}, 
                            clicksWeek: ${data.clicksWeek}, 
                            clicksMonth: ${data.clicksMonth}, 
                            clicksRedirectOfferId: ${data.clicksRedirectOfferId}, 
                            salesDay: ${data.salesDay},
                            salesWeek: ${data.salesWeek}, 
                            salesMonth: ${data.salesMonth}, 
                            salesRedirectOfferId: ${data.salesRedirectOfferId},
                            startDate: ${startDate},
                            endDate: ${endDate},
                            enabled: ${data.enabled}
                    ){
                      id,
                      campaignId,
                      clicksDay,
                      clicksWeek,
                      clicksMonth,
                      clicksRedirectOfferId
                      salesDay,
                      salesWeek,
                      salesMonth,
                      salesRedirectOfferId,
                      startDate,
                      endDate,
                      status,
                      enabled
                    }
            }  

            `,
        }
    )

    const response = res.data.data.updateCap;
    console.log(`\ncreate Cap updated: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }
}

const massAction = async (data) => {

  try {
    const res = await api.post(
        '', {
          query: `
                 mutation {
                    massCampaignUpdate(status: "${data.status}", ids: [${data.ids}])
                 }
            `,
        }
    );

    const response = res.data.data.massAction;
    console.log(`\nCampaign updated: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getCampaignDetails = async (id) => {
  try {
    const result = await api.post(
        '', {
          query: `
            {
              campaignDetails(campaignId:${id}){
                id
                sub_ids
                variantId
                customOptions
              }
            }
          `,
        });

    return result.data.data.campaignDetails;

  } catch (err) {
    console.error(err)
  }
}

const updateCampaignDetails = async (id, subIds, variantId) => {
    try {
        const result = await api.post(
            '', {
                query: `
                   mutation {
                      updateCampaignDetails(campaignId: ${id}, subIds: "${subIds}", variantId: ${variantId})
                    }
          `,
            });

        return result.data.data.updateCampaignDetails;

    } catch (err) {
        console.error(err)
    }
}

const getCampaignsGeo = async (ids) => {
  try {

    const result = await api.post(
        '', {
          query: `
            {
              campaignsGeo(ids:[${ids}]) {
                id
                name
                programs
                link
              }
            }
          `,
        });

    return result.data.data.campaignsGeo

  } catch (err) {
    console.error(err)
  }
}

/** New request created for replacing getCampaigs todo replace names once getCampaigns is totaly deprecaed */
const getCampaignsData = async (data) => {
  try {
    let preparedFilters = ''

    for (const filter in data.payload.filters) {
      preparedFilters += (!!data.payload.filters[filter]) ?
          `${filter}: "${data.payload.filters[filter]}"` : ''
    }
    const workspace = localStorage.getItem('workspace');
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateCampaigns(
            showInactiveCampaigns: ${data.payload.showInactiveCampaigns}, 
            pagination: {
              page: ${data.payload.page},
              limit: ${data.payload.limit}
            }, sorting: {
              orderBy: "${data.payload.orderBy}",
              orderDirectionAsc: ${data.payload.orderDirectionAsc}
            }, filters: {${preparedFilters}}) {
              count,
              data {
                affNameId,
                affiliateId,
                offerId,
                offerName,
                id,
                name,
                currency,
                currencyId,
                currencyName,
                payIn,
                payOut,
                percentPayout,
                payOutOffer,
                minPayOut
                minPayIn
                maxPayOut
                maxPayIn
                affiliateManager,
                affiliateManagerId,
                status,
                dateAdded,
                url,
                capId,
                enabled,
                sales_day,
                sales_week,
                sales_month,
                sales_redirect_offer_id,
                clicks_day,
                clicks_week,
                clicks_month,
                clicks_redirect_offer_id,
                startDate,
                endDate,
                marginType,
                programOverride
                programName
                programId
                lastSaleDate
                postbackUrl
                sub_ids
                affiliateMultiPings
              }
            }
          }
        `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': workspace
          }
        }
    )

    if(result.data.errors) {
      throw new Error(result.data.errors[0].message);
    }

    // console.log('affiliateCampaigns');
    console.log(`getCampaignsData response: { count: ${result.data.data.affiliateCampaigns.count} } `);

    return {
      data: result.data.data.affiliateCampaigns.data,
      count: result.data.data.affiliateCampaigns.count
    }

  } catch (err) {
    throw err;
  }
}

const getFilter = async (data) => {
  // todo repeatable code can be moved to helper
  const preparedFilter = []
  if(data.filter) {
    for (let i = 0; i < data.filter.length; i++) {
      preparedFilter.push(
          (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
      )
    }
  }

  data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

  const result = await request.post(`/graphql`, {
        query: `
          {
            campaignFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )

  if(result.status === 200) {
    const prettyData = [];
    if(result.data.data.campaignFilterData) {
      for(let i = 0; i < result.data.data.campaignFilterData.length; i++) {
        prettyData.push(result.data.data.campaignFilterData[i]);
      }
      return prettyData;
    }
  }
}

const campaignPostbacks = async (id) => {

  const result = await request.post(`/graphql`, {
        query: `
          {
            campaignPostbacks(campaignId: ${id}) {
              id,
              postback,
              type,
              event
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  );

  return result.data.data.campaignPostbacks;


}

const updateCampaignSubIds = async ({ campaignId, sub_ids }) => {
  const workspace = localStorage.getItem('workspace');
  try {
    const res = await api.post(
      '', {
        query: `
          mutation {
            updateCampaignSubIds(
              campaignId: ${campaignId}
              subIds: """${sub_ids}"""
            )
          }
        `,
      }, {
        headers: {
          workspace: workspace
        }
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    return res.data.data.updateCampaignSubIds;
  } catch (err) {
    console.error("Error updating sub_ids:", err);
    return false;
  }
};

const updateCampaignPostbacks = async ({ campaignId, postbacks }) => {
    const workspace = localStorage.getItem("workspace");

    const postbacksString = postbacks
        .map(pb => `{ id: ${pb.id ? `${pb.id}` : null}, url: """${pb.url}""", event: """${pb.event}""", type: """${pb.type}""" }`)
        .join(", ");

    try {
        const res = await api.post(
            "",
            {
                query: `
                  mutation {
                    updateCampaignPostbacks(
                      campaignId: ${campaignId}
                      postbacks: [${postbacksString}]
                    )
                  }
                `,
            },
            {
                headers: {
                    workspace: workspace,
                },
            }
        );

        if (res.data.errors) {
            return false;
        }

        return res.data.data.updateCampaignPostbacks;
    } catch (err) {
        console.error(err);
        return false;
    }
};

const updateCampaignCustomOptions = async (campaignId, customOptionIds) => {
  try {
    const workspace = localStorage.getItem("workspace");

    const res = await api.post(
      "",
      {
        query: `
          mutation {
            updateCampaignCustomOptions(
              campaignId: ${campaignId}
              customOptionIds: "${customOptionIds}"
            )
          }
        `,
      },
      {
        headers: {
          workspace: workspace,
        },
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    return res.data.data.updateCampaignCustomOptions;
  } catch (err) {
    console.error("Error updating campaign custom options:", err);
    return false;
  }
};

export default {
  getCampaigns,
  getOfferNames,
  getCampaignNames,
  getAffNamesIds,
  getManagersNamesIds,
  getCampaignStatuses,
  createCampaign,
  getUsers,
  getCampaignUrl,
  getFilter,
  getCampaignsData,
  updateCampaign,
  updateCap,
  campaignHistory,
  getPingRate,
  massAction,
  getCampaignsGeo,
  getCampaignDetails,
  updateCampaignDetails,
  updateCampaignSubIds,
  campaignPostbacks,
  updateCampaignPostbacks,
  updateCampaignCustomOptions
}
